export const colorsLight = {
  $light: '#ffffffa6',
  $lightest: '#ffffff',
  $online: '#1757B7',
  $offline: '#D9D9D9',
  $warning: '#faad14',
  $dark: '#000000a6',
  $darkest: '#000000',
  $errors: '#f52f39',
  $gray_background: '#1F1E1E',
  $select: '#1757b7',
  $primary: '#1757b7',
  $primary_bland: '#e7f0ff',
  $primary_deep: '#0a3d88',
};
